import { CmsMeta } from '../cmsMeta';
import { Link } from 'react-router-dom';
import { useLoop54ProductsByIds } from '../../../hooks/useLoop54ProductsByIds';
import { useTranslation } from '../../../i18n/i18n';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import { Loader } from '../../Loader/Loader';
import { ProductListing } from '../../ProductListing/ProductListing';
import { renderTemplate, sortByIdOrder } from '../../utils';

type CmsProductListLoop54Props = {
	ids: number[];
	moreUrl?: string;
	title: string;
	limit?: number;
	offset?: number;
	renderItemLabel?: boolean;
};

export const CmsProductListLoop54 = ({
	ids,
	moreUrl,
	title,
	limit,
	offset,
	renderItemLabel = true,
}: CmsProductListLoop54Props): JSX.Element => {
	const t = useTranslation().sort;
	const tGeneric = useTranslation().generic;
	const productIdArray = ids.map((id) => id.toString().trim());

	const takeCount = limit || productIdArray.length;

	const { error, data: products } = useLoop54ProductsByIds(ids);

	if (error) return <ErrorMessage />;
	if (!products) return <Loader size="line" />;
	if (!products || products.results.count === 0) return <ErrorMessage />;

	const sortedProducts = sortByIdOrder([...products.results.items], productIdArray);

	return (
		<div className="cms-product-listing">
			<h2>
				{title} {renderItemLabel && <small>({renderTemplate(t.items, { total: takeCount })})</small>}
			</h2>
			<ProductListing products={sortedProducts.slice(offset || 0, (offset || 0) + takeCount)} />
			{moreUrl && (
				<div className="text-center view-more-button">
					<Link className="button" to={moreUrl}>
						{tGeneric.viewMore}
					</Link>
				</div>
			)}
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A row of named products, in the order given. Use it when the choice matters; use CmsProductListCategoryLoop54 when a whole category will do.',
	example: [
		'CmsProductListLoop54',
		{ title: 'Unsere Empfehlungen fürs Homeoffice', ids: [46402, 53581, 54124, 23597] },
	],
};
